import CryptoJS from 'crypto-js';
 
let aesUtils = {};
let staticKey = "OmtDveMuj4Xl29te";
let staticValue = "PG0fmICo1H1tPeff";
const currentpkey = getParam("pkey");
if (currentpkey) {
    staticKey = currentpkey;
    staticValue = "P13fpICh2H3tzevf";
}
aesUtils.aesEncrypt=function(word){
    var key = CryptoJS.enc.Utf8.parse(staticKey);
    var iv= CryptoJS.enc.Utf8.parse(staticValue);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {iv:iv,mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
}
aesUtils.aesDecrypt=function (word){
    var key = CryptoJS.enc.Utf8.parse(staticKey);
    var iv= CryptoJS.enc.Utf8.parse(staticValue);
    var decrypt = CryptoJS.AES.decrypt(word, key, {iv:iv,mode : CryptoJS.mode.CBC,padding : CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
function getParam(queryName) {
    let query = decodeURI(window.location.search.substring(1));
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === queryName) { return pair[1]; }
    }
    return null;
}
export { aesUtils }